
export const Names = {};

function randomInt(low, high) {
    return Math.floor(Math.random() * (high - low + 1) + low);
}
function randomOf(...args){
    return args[randomInt(0, args.length - 1)];
}

const humanMaleNormalSounding = function() {
    let q = randomOf(
        'Le',
        'Lu',
        'Ma',
        'He',
        'Jai',
        'Jo',
        'Je',
        'De',
        'Da',
        'Wi',
        'We',
        'Wa',
        'O',
        'Pra',
        'Ca',
        'Cha'
    )
    let w = randomOf(
        'mie',
        'ster',
        'nnard',
        'nnis',
        'rshal',
        'ckard',
        'rold',
        'rome',
        'rry',
        'den',
        'dren',
        randomOf('nneas', 'nnius'),
        'nten',
        'llen',
        randomOf('lden', 'lton'),
        randomOf('ston', 'ngston', 'rlston'),
        'llace',
        'ller',
        randomOf('lder', 'lter'),
        'dwin'
    )
    return q + w
}
const humanFemaleNormalSounding = function() {
    let q = randomOf(
        'Lo',
        'La',
        'Li',
        'Do',
        'Da',
        'De',
        'Ja',
        'A',
        'Ca',
        'Mo',
        'Moi',
        'Ma',
        'Wi',
        'Ve',
    )
    let w = randomOf(
        'nna',
        'nessa',
        'nette',
        'cely',
        'cey',
        'rcey',
        'rra',
        'rry',
        'bbie',
        'la',
        'lissa',
        'lina',
        'lma',
        'lanie',
        'rette',
        'rena',
        randomOf('tty', 'thy'),
        'raine',
        'ssa',
        'rlyn',
        'ndra',
        'dia'
    )
    return q + w
}
const humanMale2	= function(){
    var q = randomOf(
        "Loth",
        "Fal",
        "Ren",
        "Reh",
        "Faran",
        "Ara",
        "El",
        "Al",
        "Are",
        "Ar",
        "Tor",
        "Cal",
        "Kael",
        "Ron",
        "In",
        "Quen",
        "Erin",
        "Ed",
        "Fred",
        "Tron",
        "Rol",
        "Rod",
        "Ger",
        "Gar",
        "Aran",
        "Fin",
        "Rene",
        "Bene",
        "Ala",
        "Wil",
        "Stron",
        "Sto",
        "Geth",
        "Bal",
        "Kol",
        "Lod",
        "Lar",
        "Newl",
        "Fron");
    var w = randomOf(
        "ren",
        "red",
        "rik",
        "stad",
        "gar",
        "rald",
        "gorn",
        "wen",
        "alt",
        "rond",
        "rod",
        "vik",
        "ven",
        "lon",
        "ias",
        "bran",
        "brad",
        "gram",
        "gham",
        "lod",
        "bal",
        "io",
        "lin",
        "zad",
        "dorn",
        "wick",
        "lon",
        "nalt");
    return q + w;
}
const humanMale1	= function(){
    var q = randomOf(
        "Aaron",
        "Alva",
        "Clyde",
        "Derick",
        "Donnie",
        "Ed",
        "Jack",
        "John",
        "Kenny",
        "Nelson",
        "Noah",
        "Rolf",
        "Randel",
        "Austin",
        "Bruce",
        "Charlie",
        "George",
        "Jaime",
        "Tywin",
        "Sean",
        "Steven",
        "Donnie",
        "Father",
        "Simon",
        "Warren" ,
        "Brendan",
        "Richard",
        "William",
        "Jonah",
        "Alex",
        "Jake",
        "Edward",
        "Wheaton",
        "Elvis",
        "Robert",
        "Michael",
        "David",
        "Daniel",
        "Mark",
        "Paul",
        "Charles",
        "Timothy",
        "Frank",
        "Peter",
        "Harrison",
        "Nathan",
        "Ben",
        "Mason420BlazeItILLIMUNATICONFIRMEDPLS",
        "Liam",
        "Muhammad");
    return q;
}
const humanSurname	= function(){
    var q = randomOf(
        "Robertson ",
        "Flynn ",
        "Fry ",
        "Tyler ",
        "Osborn ",
        "Freeman ",
        "Miller ",
        "Smith ",
        "Williams ",
        "Brown ",
        "Miller ",
        "Jones ",
        "Moore ",
        "Wright ",
        "Kings ",
        "Green ",
        "Campbell ",
        "Carter ",
        "Roberts ",
        "Steward",
        "Wood ",
        "Grey ",
        "Hughes ",
        "Fisher ",
        "Wilson ",
        "Pressler ",
        "Hicks ",
        "Rogers ",
        "Potts ",
        "Black ",
        "Wrynn ",
        "Fitch ",
        "Folsom ",
        "Field ",
        "Gregory ",
        "Wilfort ",
        "Tillsdale ",
        "Locke ",
        "Martin ",
        "Weller ",
        "Herald ",
        "Granger ",
        "Barnaby ",
        "Meyer ",
        "Jackson ",
        "Vaughn ",
        "Pressler ",
        "Tanner ",
        'Skinner',
        "Rowe ");
    return q;
}
Names.humanMale		= function() {
    return randomOf(humanMaleNormalSounding(), humanMale1(), humanMale2()) + ' ' + humanSurname()
}
Names.humanFemale	= function(){
    var q = randomOf(
        "Adela",
        "Adelaide",
        "Mother",
        "Helga",
        "Becky",
        "Sophie",
        "Juliet",
        "Margot",
        "Dareth",
        "Shelby",
        "Aldin",
        "Steven",
        "Grif",
        "Hegnar",
        "Jordan",
        "Deena",
        "Kendra",
        "Carson",
        "Dorthy",
        "Helen",
        "Ella",
        "Lena",
        "Sasha",
        "Triss",
        "Trisha",
        "Alissa",
        "Annie",
        "Grace",
        "Lily",
        "Margery",
        "Gwen",
        "Isabelle",
        "Kyrsten",
        "Catelyn",
        "Myrra",
        "Sherrie",
        "Alyson",
        "Cindy",
        "Diana",
        "Melanie",
        "Sara",
        "Lydia",
        "Madelyn",
        "Sara",
        "Deidre",
        'Geraldine',
        "Liza",
        "Wilma",
        "Aisha",
        "Heather",
        "Abby");
    return randomOf(q, humanFemaleNormalSounding()) + ' ' + humanSurname();
}